import { loadStripe, type Stripe } from '@stripe/stripe-js/pure';

const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
if (!publishableKey) {
    console.warn('[Stripe] VITE_STRIPE_PUBLISHABLE_KEY is not set — donation flows will fail until it is configured.');
}

/**
 * Stripe.js, loaded on FIRST USE — never at import time.
 *
 * This module also exports the API/donation constants, so a module-scope
 * loadStripe() meant that merely importing a constant pulled Stripe.js into
 * every route and set its __stripe_mid/__stripe_sid cookies site-wide, before
 * any payment intent and before consent.
 *
 * The import is '@stripe/stripe-js/pure', not '@stripe/stripe-js': the DEFAULT
 * entry injects the js.stripe.com script as soon as the module is evaluated, so
 * deferring the call is not enough on its own.
 */
let stripePromiseCache: Promise<Stripe | null> | null = null;
export function getStripe(): Promise<Stripe | null> {
    stripePromiseCache ??= publishableKey ? loadStripe(publishableKey) : Promise.resolve(null);
    return stripePromiseCache;
}

// Platform fee percentage
export const PLATFORM_FEE_PERCENTAGE = 0.05; // 5% platform fee

// Cloud Functions base URL
// Prefer explicit VITE_API_URL; otherwise fall back to default Functions URL based on project id
const fallbackFunctionsBase = import.meta.env.VITE_FIREBASE_PROJECT_ID
    ? `https://us-central1-${import.meta.env.VITE_FIREBASE_PROJECT_ID}.cloudfunctions.net`
    : '';
export const API_BASE_URL = import.meta.env.VITE_API_URL || fallbackFunctionsBase;

export const DONATION_ENDPOINTS = {
    oneOff: '/createOneOffDonation',
    monthlySetup: '/createMonthlyDonationSetup',
    monthlyConfirm: '/confirmMonthlyDonation',
};